import React, { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";
import SalonService from "../../services/SalonService";
import "./NotificationBell.css";

export default function NotificationBell({ customerId }) {
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        const fetchCount = async () => {
            if (customerId && customerId !== "null") {
                try {
                    const res = await SalonService.getUnreadCount(customerId);
                    setUnreadCount(res.data || 0);
                } catch (error) {
                    console.error("Failed to fetch unread count", error);
                    setUnreadCount(0);
                }
            }
        };

        fetchCount();

        // Refresh every 2 minutes
        const interval = setInterval(fetchCount, 120000);
        return () => clearInterval(interval);
    }, [customerId]);

    return (
        <div className="premium-bell-nav">
            <span className="bell-wrapper">
                <FaBell className="bell-icon" />
                {unreadCount > 0 && (
                    <span className="premium-badge-glow">
                        {unreadCount > 99 ? '9+' : unreadCount}
                    </span>
                )}
            </span>
            <span className="bell-label">Notifications</span>
        </div>
    );
}
